import DOMPurify from 'dompurify';

/**
 * Sanitize HTML string to prevent XSS attacks
 * @param {string} str - The string to sanitize
 * @returns {string} - The sanitized string
 */
export function cleanString(str) {
  if (typeof str !== 'string') return str;
  return DOMPurify.sanitize(str);
}

/**
 * Recursively sanitize HTML in object values to prevent XSS attacks
 * @param {any} obj - The object to process
 * @returns {any} - The object with sanitized HTML strings
 */
export function cleanObjectBlockXSSAttack(obj) {
  if (typeof obj === 'string') {
    return cleanString(obj);
  }
  if (Array.isArray(obj)) {
    return obj.map(cleanObjectBlockXSSAttack);
  }
  if (obj && typeof obj === 'object') {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      result[key] = cleanObjectBlockXSSAttack(value);
    }
    return result;
  }
  return obj;
}
